
import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import vSelect from "vue-select";

// Types
import { UserPermissions, FeaturesList } from "@/store/types";
import { UserManagementState, UserDetails, UserRole } from "@/store/user-management/types";
import { SiteTreeNode, Group } from "@/store/eventqueue/types";

// 3rd Party components
import { get } from "lodash";
import TextHighlight from "vue-text-highlight";

// SV components
import NavHeader from "@/components/NavHeader.vue";

import UserRoleSetup from "@/components/setup/users/UserRoleSetup.vue";
import UserGroupSetup from "@/components/setup/users/UserGroupSetup.vue";
import ActiveDirectorySetup from "@/components/setup/active-directory/ActiveDirectorySetup.vue"

import api from "@/services/api.service";
import GenericUpdateModal from "@/components/table/generic-update-modal.vue";
import LDAPManagementModal from "@/components/setup/active-directory/LDAPManagementModal.vue";

// VueX namespaces
const Eventqueue = namespace("eventqueue");
const UserManagement = namespace("userManagement");
const AreaStore = namespace("areas");

@Component({
	components: {
		"nav-header": NavHeader,
		"user-role-setup": UserRoleSetup,
		"user-group-setup": UserGroupSetup,
		"v-select": vSelect,
		"active-directory-setup": ActiveDirectorySetup,
		"ldap-management-modal": LDAPManagementModal
	}
})
export default class PermissionSetup extends Vue {
	@Mutation private setIsLoading: (loading: boolean) => void;

	@Getter("getFeaturesList") featuresList: FeaturesList;
	@Getter("getPermissions") permissions: any;

	@AreaStore.Action getTenants: any;

	private tenantsList: any[] = [];
	private selectedTenant: any = {};
	private ldapManagementModal: boolean = false;
	private ldapManagementButtonVisible: boolean = false;

	public get userGroupManagementEnabled() {
		return get(this.featuresList, ["UserGroups"]);
	}

	private get selectedTenantGroupId() {
		return get(this.selectedTenant, "groupID");
	}

	// Permission check to see feature flag is on, and if user is either admin or has permission to manage domains
	private get canManageDomains(): boolean {
		return (
			get(this.featuresList, ["Domains", "ActiveDirectory"]) &&
			(this.permissions.isAdmin || this.permissions.canManageDomains)
		);
	}

	/*
	 * On mount, do feature and permissions checks - if invalid, go back
	 */
	public async mounted() {
		if (!this.permissions.isAdmin && (!this.permissions.canEditUserGroups || !this.permissions.canEditUserGroups)) {
			this.$router.go(-1);
		}

		this.tenantsList = await this.getTenants();

		// set the tenant id based on the isUsersTenant value
		this.tenantsList.forEach(tenant => {
			if (tenant.isUsersTenant) {
				this.selectedTenant = tenant;
			}
		});
	}

	private displayLDAPManagementModal(): void {
		this.setIsLoading(true);
		this.ldapManagementModal = !this.ldapManagementModal;
	}

	public handleActiveDirectoryTabActive(): void {
		this.ldapManagementButtonVisible = true;
	}

	public handleUserGroupsTabActive(): void{
		this.ldapManagementButtonVisible = false;
	}

	public handleUserRolesTabActive(): void {
		this.ldapManagementButtonVisible = false;
	}
}
